import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {Navigate} from "react-router-dom";
import Header from "./Header";
import axios from 'axios';
// import LoginBg from '../images/logo-150.jpeg';

 
import Menu from "./Menu";

const Wrapper = ({children, pageTitle })=>{
    const [redirect, setRedirect] = useState(false);
    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    useEffect(  () =>{
        (
         async () => {
            try {
                const {data} = await axios.get("vibesUser");
                //const {data} = await axios.get("user");
                console.log(data.message);
            } catch (error) {
                
                setRedirect(true);
            }
            
            
         }
        )();
      }, []);

      if(redirect){
        return <Navigate to={'/login'} />;
      }

    return (
        <div className={`flex h-screen bg-gray-50 dark:bg-gray-900 ${isSideMenuOpen ? 'overflow-hidden' : ''}`} >  
            <aside  className="z-20 hidden w-64 overflow-y-auto bg-white dark:bg-gray-800 md:block flex-shrink-0" >
            <div className="py-4 text-gray-500 dark:text-gray-400">
            <Link  className="ml-6 text-lg font-bold text-red-500 dark:text-red-200"  to={'/'} > MimiNiSisi
{/*             
            <img
              aria-hidden="true"
              className="object-cover w-full h-full dark:hidden"
              src={LoginBg}
              alt="Office"
            /> */}
            </Link>

           <Menu  />

            </div>
                
            </aside>
           

            <div className="flex flex-col flex-1 w-full">
                <header className="z-10 py-4 bg-white shadow-md dark:bg-gray-800">
                    <Header />
                </header>
                <main className="h-full overflow-y-auto">
                    <div className="container px-6 mx-auto grid" >
                    <h2 className="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200" >  {pageTitle} </h2>

                   {children}

                    </div>
                </main>
            </div>
        </div>
        );
};

export default Wrapper;